// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Project$ReactHooksTemplate = require("./project.res.js");
var FormModal$ReactHooksTemplate = require("./FormModal.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var Notification$ReactHooksTemplate = require("../common/Notification.res.js");
var SurveyCreate$ReactHooksTemplate = require("./SurveyCreate.res.js");
var SurveyMetaEdit$ReactHooksTemplate = require("./SurveyMetaEdit.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var SurveyPageSearch$ReactHooksTemplate = require("./SurveyPageSearch.res.js");
var SurveySummaryCards$ReactHooksTemplate = require("./SurveySummaryCards.res.js");

function decodeSurvey(json) {
  var partial_arg = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined);
  var partial_arg$1 = function (param) {
    return Json_decode.withDefault(partial_arg, DomainModel$ReactHooksTemplate.$$String.Email.decode, param);
  };
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json),
          createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
          createdBy: Json_decode.field("creator", (function (param) {
                  return Json_decode.field("email", partial_arg$1, param);
                }), json)
        };
}

var searchPlaceholder = "Search surveys...";

function SurveyList$TruncatedText(props) {
  var __className = props.className;
  var text = props.text;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("span", {
              children: text,
              className: "block truncate " + className,
              style: props.style,
              title: text
            });
}

var TruncatedText = {
  make: SurveyList$TruncatedText
};

function SurveyList$SurveyActions(props) {
  if (!props.canEdit) {
    return null;
  }
  var onEdit = props.onEdit;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("button", {
                    children: JsxRuntime.jsx("img", {
                          className: "h-14-px opacity-70",
                          src: Image$ReactHooksTemplate.edit
                        }),
                    className: "w-8 h-8 flex items-center justify-center rounded-lg hover:bg-blue-50 focus:outline-none",
                    title: "Edit survey name and type",
                    type: "button",
                    onClick: (function (param) {
                        Curry._1(onEdit, undefined);
                      })
                  }),
              className: "flex items-center justify-end gap-1"
            });
}

var SurveyActions = {
  make: SurveyList$SurveyActions
};

function SurveyList(props) {
  var onStatsChange = props.onStatsChange;
  var setLiveOnly = props.setLiveOnly;
  var liveOnly = props.liveOnly;
  var match = React.useState(function (param) {
        return "GetSurveys";
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return PaginationUtils$ReactHooksTemplate.emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        return 1;
      });
  var setCurrentPage = match$2[1];
  var currentPage = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setSurveyCreate = match$3[1];
  var surveyCreate = match$3[0];
  var match$4 = React.useState(function (param) {
        
      });
  var setSurveyToEdit = match$4[1];
  var surveyToEdit = match$4[0];
  var match$5 = React.useState(function (param) {
        
      });
  var setNotification = match$5[1];
  var notification = match$5[0];
  var match$6 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var match$7 = React.useState(function (param) {
        
      });
  var setSearchKey = match$7[1];
  var searchKey = match$7[0];
  var match$8 = React.useState(function (param) {
        return 0;
      });
  var setLiveCount = match$8[1];
  var liveCount = match$8[0];
  var match$9 = React.useState(function (param) {
        return 0;
      });
  var setProjectTotalCount = match$9[1];
  var projectTotalCount = match$9[0];
  var skipSearchDebounce = React.useRef(true);
  var skipLiveDebounce = React.useRef(true);
  var projectId = Belt_Option.getExn(Project$ReactHooksTemplate.id(props.selectedProject));
  var canEdit = Curry._1(match$6[0], "BuildSurvey");
  var fetchSurveys = function (currentPage, searchKey, liveOnly) {
    var liveQuery = liveOnly ? "&live=true" : "";
    var url = searchKey !== undefined ? "/api/v1/projects/" + (String(projectId) + ("/surveys?search=" + (searchKey + ("&page=" + (String(currentPage) + liveQuery))))) : "/api/v1/projects/" + (String(projectId) + ("/surveys?page=" + (String(currentPage) + liveQuery)));
    return Js_promise.then_((function (param) {
                  var pageInfo = PaginationUtils$ReactHooksTemplate.fromFetchHeaders(param[0]);
                  var payload = Js_promise.then_((function (json) {
                          var surveys = Json_decode.field("surveys", (function (param) {
                                  return Json_decode.list(decodeSurvey, param);
                                }), json);
                          var liveCount = Json_decode.withDefault(0, (function (param) {
                                  return Json_decode.field("live_count", Json_decode.$$int, param);
                                }), json);
                          var projectTotalCount = Json_decode.withDefault(0, (function (param) {
                                  return Json_decode.field("total_count", Json_decode.$$int, param);
                                }), json);
                          return Promise.resolve([
                                      surveys,
                                      liveCount,
                                      projectTotalCount
                                    ]);
                        }), param[1]);
                  return Promise.resolve([
                              payload,
                              pageInfo
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var reloadSurveys = function (page, key, liveOnly) {
    Js_promise.then_((function (param) {
            var paginationInfo = param[1];
            Curry._1(setPageInfo, (function (param) {
                    return paginationInfo;
                  }));
            return Js_promise.then_((function (param) {
                          var nextProjectTotalCount = param[2];
                          var nextLiveCount = param[1];
                          var surveys = param[0];
                          Curry._1(setLiveCount, (function (param) {
                                  return nextLiveCount;
                                }));
                          Curry._1(setProjectTotalCount, (function (param) {
                                  return nextProjectTotalCount;
                                }));
                          Curry._1(setState, (function (param) {
                                  return {
                                          TAG: "Ready",
                                          _0: surveys
                                        };
                                }));
                          return Promise.resolve();
                        }), param[0]);
          }), fetchSurveys(page, key, liveOnly));
  };
  var handleSurveySearchChange = function (value) {
    Curry._1(setSearchKey, (function (param) {
            if (value === "") {
              return ;
            } else {
              return value;
            }
          }));
  };
  var handlePageChange = function (pageNumber) {
    Curry._1(setCurrentPage, (function (param) {
            return pageNumber;
          }));
    reloadSurveys(pageNumber, searchKey, liveOnly);
  };
  React.useEffect((function (param) {
          if (typeof state === "object") {
            var surveys = state._0;
            var searchQuery = Belt_Option.getWithDefault(searchKey, "");
            var pageCount = searchQuery === "" ? Belt_List.length(surveys) : Belt_List.length(Belt_List.keep(surveys, (function (survey) {
                          if (Utils$ReactHooksTemplate.matchesSearchQuery(searchQuery, survey.name)) {
                            return true;
                          } else {
                            return Utils$ReactHooksTemplate.matchesSearchQuery(searchQuery, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, survey.createdBy));
                          }
                        })));
            var searchSummary = liveOnly ? (
                searchQuery === "" ? "Active campaign surveys" : "Live matching \"" + searchQuery + "\""
              ) : (
                searchQuery === "" ? "Visible in this project" : "Matching \"" + searchQuery + "\""
              );
            Curry._1(onStatsChange, {
                  projectTotalCount: projectTotalCount,
                  liveCount: liveCount,
                  pageCount: pageCount,
                  searchSummary: searchSummary
                });
          }
          
        }), [
        state,
        liveCount,
        projectTotalCount,
        liveOnly,
        searchKey
      ]);
  React.useEffect((function (param) {
          skipSearchDebounce.current = true;
          skipLiveDebounce.current = true;
          Curry._1(setCurrentPage, (function (param) {
                  return 1;
                }));
          Curry._1(setSearchKey, (function (param) {
                  
                }));
          Curry._1(setLiveOnly, false);
          Curry._1(onStatsChange, SurveySummaryCards$ReactHooksTemplate.empty());
          reloadSurveys(1, undefined, false);
        }), [projectId]);
  React.useEffect((function (param) {
          if (skipSearchDebounce.current) {
            skipSearchDebounce.current = false;
          } else {
            Curry._1(setCurrentPage, (function (param) {
                    return 1;
                  }));
            reloadSurveys(1, searchKey, liveOnly);
          }
        }), [searchKey]);
  React.useEffect((function (param) {
          if (skipLiveDebounce.current) {
            skipLiveDebounce.current = false;
          } else {
            Curry._1(setCurrentPage, (function (param) {
                    return 1;
                  }));
            reloadSurveys(1, searchKey, liveOnly);
          }
        }), [liveOnly]);
  var toggleSurveyCreate = function (param) {
    Curry._1(setSurveyCreate, (function (param) {
            return !surveyCreate;
          }));
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  if (typeof state !== "object") {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "h-8 w-8",
                        src: Image$ReactHooksTemplate.dashboardLoading
                      }),
                  JsxRuntime.jsx("span", {
                        children: "Loading surveys...",
                        className: "ml-3 text-sm text-aurometalsaurus"
                      })
                ],
                className: "flex items-center justify-center py-20"
              });
  }
  var surveys = state._0;
  var searchQuery = Belt_Option.getWithDefault(searchKey, "");
  var displaySurveys = searchQuery === "" ? surveys : Belt_List.keep(surveys, (function (survey) {
            if (Utils$ReactHooksTemplate.matchesSearchQuery(searchQuery, survey.name)) {
              return true;
            } else {
              return Utils$ReactHooksTemplate.matchesSearchQuery(searchQuery, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, survey.createdBy));
            }
          }));
  return JsxRuntime.jsxs("div", {
              children: [
                notification !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Notification$ReactHooksTemplate.make, {
                              text: notification[0],
                              isError: notification[1],
                              handleClose: (function (param) {
                                  Curry._1(setNotification, (function (param) {
                                          
                                        }));
                                })
                            }),
                        className: "pt-1"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(SurveyPageSearch$ReactHooksTemplate.make, {
                                                  value: Belt_Option.getWithDefault(searchKey, ""),
                                                  onChange: handleSurveySearchChange,
                                                  searchPlaceholder: searchPlaceholder,
                                                  compact: true
                                                }),
                                            className: "w-full"
                                          }),
                                      className: "flex-1 min-w-0 sm:flex-none sm:w-full sm:max-w-sm flex items-center"
                                    }),
                                canEdit ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "+",
                                                      className: "text-base leading-none font-bold pointer-events-none"
                                                    }),
                                                "New Survey"
                                              ],
                                              className: "inline-flex items-center justify-center gap-1.5 sm:gap-2 h-9 px-3 sm:px-4 leading-none bg-pigmentblue text-white text-sm font-semibold rounded-lg hover:bg-cetaceanblue hover:shadow-md active:bg-cetaceanblue focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-2 transition-all duration-200 cursor-pointer whitespace-nowrap",
                                              id: "add-survey",
                                              style: {
                                                height: "36px"
                                              },
                                              type: "button",
                                              onClick: toggleSurveyCreate
                                            }),
                                        className: "flex-shrink-0 flex items-center"
                                      }) : null
                              ],
                              className: "flex flex-row items-center justify-between gap-2 sm:gap-3 pb-4"
                            }),
                        JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                              currentPage: currentPage,
                              totalPages: totalPagesCount,
                              totalRecords: totalCount,
                              perPage: perPageCount,
                              handlePageChange: handlePageChange,
                              itemLabel: "surveys",
                              className: "mb-4"
                            })
                      ],
                      className: "flex-shrink-0 pt-4 lg:pt-6"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("table", {
                                  children: [
                                    JsxRuntime.jsx("thead", {
                                          children: JsxRuntime.jsxs("tr", {
                                                children: [
                                                  JsxRuntime.jsx("th", {
                                                        children: "Name",
                                                        className: "px-4 lg:px-5 py-3 text-10-px font-bold uppercase tracking-wider min-w-150-px"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Created by",
                                                        className: "px-4 lg:px-5 py-3 text-10-px font-bold uppercase tracking-wider hidden md:table-cell min-w-150-px"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Created at",
                                                        className: "px-4 lg:px-5 py-3 text-10-px font-bold uppercase tracking-wider hidden sm:table-cell"
                                                      }),
                                                  canEdit ? JsxRuntime.jsx("th", {
                                                          children: "Actions",
                                                          className: "px-4 lg:px-5 py-3 text-10-px font-bold uppercase tracking-wider w-20 text-right"
                                                        }) : null
                                                ]
                                              }),
                                          className: "font-medium bg-gray-50 text-aurometalsaurus border-b border-gray-200 sticky top-0 z-10"
                                        }),
                                    JsxRuntime.jsx("tbody", {
                                          children: Belt_List.length(displaySurveys) === 0 ? JsxRuntime.jsx("tr", {
                                                  children: JsxRuntime.jsx("td", {
                                                        children: searchQuery === "" ? "No surveys found." : "No surveys match your search.",
                                                        className: "px-5 py-12 text-center text-aurometalsaurus text-sm",
                                                        colSpan: canEdit ? 4 : 3
                                                      })
                                                }) : $$Array.of_list(Belt_List.map(displaySurveys, (function (survey) {
                                                        var id = String(survey.id);
                                                        var editUrl = "/projects/" + String(projectId) + "/surveys/edit/" + id;
                                                        return JsxRuntime.jsxs("tr", {
                                                                    children: [
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsxs("a", {
                                                                                  children: [
                                                                                    JsxRuntime.jsx("div", {
                                                                                          children: survey.name[0],
                                                                                          className: "w-8 h-8 flex items-center justify-center text-white uppercase text-sm font-bold rounded-lg flex-shrink-0 " + Utils$ReactHooksTemplate.randomBgColor()
                                                                                        }),
                                                                                    JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx(SurveyList$TruncatedText, {
                                                                                                  text: survey.name,
                                                                                                  className: "font-medium text-darkcharcoal hover:text-pigmentblue",
                                                                                                  style: {
                                                                                                    maxWidth: "100%"
                                                                                                  }
                                                                                                }),
                                                                                            JsxRuntime.jsx("p", {
                                                                                                  children: "SV-" + String(survey.id),
                                                                                                  className: "text-10-px text-aurometalsaurus mt-0.5 truncate"
                                                                                                })
                                                                                          ],
                                                                                          className: "min-w-0 flex-1"
                                                                                        })
                                                                                  ],
                                                                                  className: "flex items-center gap-3 min-w-0",
                                                                                  href: editUrl
                                                                                }),
                                                                            className: "px-4 lg:px-5 py-4 max-w-0"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsx("a", {
                                                                                  children: JsxRuntime.jsx(SurveyList$TruncatedText, {
                                                                                        text: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, survey.createdBy),
                                                                                        className: "text-aurometalsaurus hover:text-darkcharcoal",
                                                                                        style: {
                                                                                          maxWidth: "100%"
                                                                                        }
                                                                                      }),
                                                                                  className: "block min-w-0",
                                                                                  href: editUrl
                                                                                }),
                                                                            className: "px-4 lg:px-5 py-4 hidden md:table-cell max-w-0"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsx("a", {
                                                                                  children: survey.createdAt.format("lll"),
                                                                                  className: "text-aurometalsaurus hover:text-darkcharcoal text-xs lg:text-sm",
                                                                                  href: editUrl
                                                                                }),
                                                                            className: "px-4 lg:px-5 py-4 hidden sm:table-cell whitespace-nowrap"
                                                                          }),
                                                                      canEdit ? JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx(SurveyList$SurveyActions, {
                                                                                    canEdit: canEdit,
                                                                                    onEdit: (function (param) {
                                                                                        Curry._1(setSurveyToEdit, (function (param) {
                                                                                                return survey.id;
                                                                                              }));
                                                                                      })
                                                                                  }),
                                                                              className: "px-4 lg:px-5 py-4"
                                                                            }) : null
                                                                    ],
                                                                    className: "border-b border-gray-100 hover:bg-gray-50 transition-colors"
                                                                  }, String(survey.id));
                                                      })))
                                        })
                                  ],
                                  className: "text-left table-auto w-full text-sm font-medium",
                                  style: {
                                    minWidth: "640px"
                                  }
                                }),
                            className: "overflow-x-auto overflow-y-auto h-full"
                          }),
                      className: "bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex-1 min-h-0"
                    }),
                surveyToEdit !== undefined ? JsxRuntime.jsx(FormModal$ReactHooksTemplate.make, {
                        title: "Edit Survey",
                        onClose: (function (param) {
                            Curry._1(setSurveyToEdit, (function (param) {
                                    
                                  }));
                          }),
                        children: JsxRuntime.jsx(SurveyMetaEdit$ReactHooksTemplate.make, {
                              projectId: projectId,
                              surveyId: surveyToEdit,
                              onClose: (function (param) {
                                  Curry._1(setSurveyToEdit, (function (param) {
                                          
                                        }));
                                }),
                              onSaved: (function (param) {
                                  Curry._1(setSurveyToEdit, (function (param) {
                                          
                                        }));
                                  Curry._1(setNotification, (function (param) {
                                          return [
                                                  "Survey updated successfully",
                                                  false
                                                ];
                                        }));
                                  reloadSurveys(currentPage, searchKey, liveOnly);
                                })
                            })
                      }) : null,
                surveyCreate ? JsxRuntime.jsx(FormModal$ReactHooksTemplate.make, {
                        title: "Create New Survey",
                        onClose: toggleSurveyCreate,
                        size: "Large",
                        children: JsxRuntime.jsx(SurveyCreate$ReactHooksTemplate.make, {
                              toggleSurveyCreate: toggleSurveyCreate,
                              projectId: projectId
                            })
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "px-4 sm:px-6 lg:px-30-px pb-6 lg:pb-30-px max-w-full h-full flex flex-col min-h-0"
            });
}

var make = SurveyList;

exports.decodeSurvey = decodeSurvey;
exports.searchPlaceholder = searchPlaceholder;
exports.TruncatedText = TruncatedText;
exports.SurveyActions = SurveyActions;
exports.make = make;
/* react Not a pure module */
